import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../api/admin";

/**
 * Count of klydos with a pending publication request. Counts the requests, not
 * the klydos' draft-ness — a klydo already sealed by its collection can still
 * have one open, so this can read higher than the old draft-only count did.
 */
export const useNumberOfPendingPublicationRequests = () => {
  return useQuery<number>({
    queryKey: ["pendingPublicationRequests"],
    queryFn: async () => {
      return adminApiClient.getNumberOfPendingPublicationRequests();
    },
  });
};
